import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=4111b76c&scoped=true&functional=true&"
import script from "./Copyright.vue?vue&type=script&lang=ts&"
export * from "./Copyright.vue?vue&type=script&lang=ts&"
import style0 from "./Copyright.vue?vue&type=style&index=0&id=4111b76c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4111b76c",
  null
  
)

export default component.exports